var render = function render(){var _vm=this,_c=_vm._self._c;return _c('button',{staticClass:"btn btn-primary",attrs:{"disabled":_vm.loading}},[(_vm.loading)?_c('i',{staticClass:"fa fa-cog fa-spin"}):_vm._e(),(_vm.loading)?_c('span',[_vm._v(" ")]):_vm._e(),_vm._t("default")],2)
}
var staticRenderFns = []

export { render, staticRenderFns }